import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CheckboxFieldComponent } from "./checkbox-field.component";

@NgModule({
  declarations: [CheckboxFieldComponent],
  imports: [ReactiveFormsModule, MatCheckboxModule],
  exports: [CheckboxFieldComponent]
})
export class CheckboxFieldModule {}
